import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import en from 'vuetify/es5/locale/en';
import ja from 'vuetify/es5/locale/ja';

Vue.use(Vuetify);

export default new Vuetify({
    lang: {
      locales: { en, ja },
      current: 'ja',
    },
});
